
module.directive('newMemberForm', function($state, ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/newMemberForm',
        scope: {programId: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            scope.doSave = basicForm.doSave;

            basicForm.save = function(data, goToProfile) {
                data = angular.copy(data);
                data.grant_year = data.slot_type.year;
                data.slot_type = data.slot_type.type;

                basicForm.closeOnSave = false;

                return ModelService.postRelation('program', scope.programId,
                                                 'amc-members', data)
                    .then(function(participant) {
                        scope.form.$setPristine();
                        if (goToProfile) {
                            $state.go('student.demographics', {
                                id: participant.id,
                                type: 'participant',
                            });
                        } else {
                            scope.data = basicForm.data = {};
                        }
                    });
            };
        },
    };
});